/**
 * Safe URL logging for core photo SAS links (never print query tokens).
 * Azure blob URLs look like https://acct.blob.core.windows.net/container/path?sv=...
 */
export function redactAzureBlobUrl(url) {
  if (url == null || url === '') return '(empty)';
  if (typeof url !== 'string') return String(url);
  try {
    const u = new URL(url);
    const base = `${u.origin}${u.pathname}`;
    return u.search ? `${base}?[REDACTED_SAS]` : base;
  } catch {
    return '(invalid url)';
  }
}

/**
 * Structured console output when a core photo `<img>` fails to load.
 * @param {string} phase - 'thumbnail' | 'lightbox'
 * @param {Record<string, unknown>} [photo] - asset row when available
 * @param {object} opts
 */
export function logCorePhotoImageError(phase, photo, opts) {
  const { attempt, totalCandidates, failedUrl } = opts;
  const blobHint = photo
    ? {
        hole_id: photo.hole_id,
        file_name: photo.file_name,
        blob_container: photo.blob_container,
        blob_path: photo.blob_path,
      }
    : {};

  console.warn('[core-photos:image]', phase, 'load failed', {
    ...blobHint,
    candidateIndex: attempt,
    candidatesTriedSoFar: attempt + 1,
    totalCandidates,
    failedUrlRedacted: redactAzureBlobUrl(failedUrl),
  });
}

export function logCorePhotoImageExhausted(phase, photo, urls) {
  console.warn('[core-photos:image]', phase, 'all candidate URLs failed', {
    hole_id: photo?.hole_id,
    file_name: photo?.file_name,
    blob_container: photo?.blob_container,
    blob_path: photo?.blob_path,
    candidateUrlsRedacted: (urls || []).map(redactAzureBlobUrl),
  });
}
